export class CalendarColorKeyController {
  models: {
    colorKeys: Array<String>;
  };

  private openDialog: boolean = false;

  constructor() {
    this.models = {
      colorKeys: ['busy', 'waitlisted', 'not-registered']
    };
  }

  openDialogFn() {
    this.openDialog = true;
  }
  closeModal() {
    this.openDialog = false;
  }
}

angular
  .module('ui-ng-calendar')
  .controller('phxCalendarColorKeyController', CalendarColorKeyController)
  .component('phxCalendarColorKey', {
    templateUrl: 'ui-ng-calendar/src/views/calendar_color_key/calendar_color_key.html',
    controller: 'phxCalendarColorKeyController'
  });



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-calendar/src/views/calendar_color_key/calendar_color_key_component.ts